var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.87px)",
      clipPath: "url(#bgblur_0_3790_4499_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15.738
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#79A6D3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5082,
    stroke: "url(#paint0_linear_3790_4499)",
    strokeOpacity: 0.24,
    strokeWidth: 0.983628
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15746 12.0248L14.7921 14.9612C14.8603 14.987 14.9314 15.0002 15.0031 15.0002C15.0748 15.0002 15.1459 14.987 15.2142 14.9612L22.8488 12.0248C23.0753 11.9376 23.225 11.7197 23.225 11.4765C23.225 11.2333 23.0753 11.0154 22.8488 10.9282L15.2142 7.99184C15.0777 7.94022 14.9286 7.94022 14.7921 7.99184L7.15749 10.9282C6.93095 11.0154 6.78125 11.2333 6.78125 11.4765C6.78125 11.7197 6.93095 11.9376 7.15746 12.0248ZM15.0031 9.16927L21.0015 11.4765L15.0031 13.7837L9.00477 11.4765L15.0031 9.16927Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8488 17.9756L21.1655 17.3281L19.5293 17.9578L21.0015 18.5239L15.0031 20.8311L9.00477 18.5239L10.477 17.9579L8.84074 17.3282L7.15749 17.9757C6.93095 18.0628 6.78125 18.2807 6.78125 18.5239C6.78125 18.7671 6.93095 18.985 7.15746 19.0722L14.7921 22.0086C14.8603 22.0344 14.9314 22.0476 15.0031 22.0476C15.0748 22.0476 15.1459 22.0344 15.2142 22.0086L22.8488 19.0722C23.0753 18.985 23.225 18.7671 23.225 18.5239C23.225 18.2807 23.0753 18.0628 22.8488 17.9756Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8488 14.4522L21.1655 13.8047L19.5293 14.4344L21.0015 15.0005L15.0031 17.3077L9.00477 15.0005L10.477 14.4344L8.84074 13.8047L7.15749 14.4522C6.93095 14.5394 6.78125 14.7573 6.78125 15.0005C6.78125 15.2436 6.93095 15.4616 7.15746 15.5488L14.7921 18.4851C14.8603 18.5109 14.9314 18.5241 15.0031 18.5241C15.0748 18.5241 15.1459 18.5109 15.2142 18.4851L22.8488 15.5488C23.0753 15.4616 23.225 15.2436 23.225 15.0005C23.225 14.7573 23.0753 14.5394 22.8488 14.4522Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3790_4499_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3790_4499",
    x1: 0,
    y1: 0,
    x2: 31.283,
    y2: 28.5965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618716,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectType);
export default __webpack_public_path__ + "static/media/Select Type.12a92adc1dfd74799077c24474921b99.svg";
export { ForwardRef as ReactComponent };